/**
 * WithYouChips
 *
 * A row of quick-prompt chips shown above the chat composer when the user
 * is in a With You check-in (chat opened from a "yanamas is with you"
 * push notification or manually started).
 *
 * Tapping a chip writes its text into the composer (via onPick).
 */

import React from 'react'

interface WithYouChipsProps {
  onPick: (text: string) => void
  disabled?: boolean
}

const PROMPTS: string[] = [
  'How are you feeling right now?',
  'Anything good happen today?',
  'Anything that felt hard?',
  'What is on your mind?',
  'I just want to save a thought',
]

export const WithYouChips: React.FC<WithYouChipsProps> = ({ onPick, disabled }) => {
  return (
    <div className="flex flex-wrap gap-2 px-3 py-2">
      {PROMPTS.map((p) => (
        <button
          key={p}
          type="button"
          disabled={disabled}
          onClick={() => onPick(p)}
          className="px-3 py-1.5 text-sm rounded-full border border-brand-subtle bg-brand-subtle text-brand hover:bg-brand-subtle disabled:opacity-50"
        >
          {p}
        </button>
      ))}
    </div>
  )
}
